function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Union_1",
  "data-name": "Union 1",
  d: "M0,124V0H280.271L312,62l-31.729,62Z",
  transform: "translate(0 0)",
  fill: "#fff"
});

function SvgTriangleBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_21_1",
    "data-name": "Component 21 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 124,
    viewBox: "0 0 312 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleBg);
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ29tcG9uZW50XzIxXzEiIGRhdGEtbmFtZT0iQ29tcG9uZW50IDIxIOKAkyAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMTIiIGhlaWdodD0iMTI0IiB2aWV3Qm94PSIwIDAgMzEyIDEyNCI+DQogIDxwYXRoIGlkPSJVbmlvbl8xIiBkYXRhLW5hbWU9IlVuaW9uIDEiIGQ9Ik0wLDEyNFYwSDI4MC4yNzFMMzEyLDYybC0zMS43MjksNjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjZmZmIi8+DQo8L3N2Zz4NCg==";
export { ForwardRef as ReactComponent };